/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { AuthCompleteOnboardingResponse } from '../types/AuthCompleteOnboarding'

/**
 * POST /auth/me/onboarding/complete
 * @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::completeOnboarding
 */
export async function authCompleteOnboarding(
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AuthCompleteOnboardingResponse>> {
	return axiosInstance.post('/auth/me/onboarding/complete', undefined, config)
}
